import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReservationDialogService {
  uri = environment.uriG + "/api/test-reservation/";

  constructor(private http: HttpClient) { }

  getReservationTestByEventId(eventId): any {
 
    return this.http.get<any>(`${this.uri}/reservationTestOne/${eventId}` );
  }

  updateTestReservation(id, data): any {
    return this.http.put<any>(`${this.uri}/changeReservationEvent/${id}`, data);
  }

}
